module.exports = __webpack_public_path__ + "img/partners-sapie.642ec3c6.jpeg";